// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9adf784c","952":"e0f83b7f"}[chunkId] + ".chunk.js";
};